export class Notification {

    constructor() {

        // HTML-Code für Notis
        this.html = `
<div>
    <div class="icon">
        <svg class="success" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
            <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/>
        </svg>
        <svg class="error" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
            <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd"/>
        </svg>
    </div>
    <div class="text">
        <p class="header"></p>
        <p></p>
    </div>
    <div class="btn">
        <button type="button" style="display:flex">
            <span>Dismiss</span>
            <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
        </button>
    </div>
</div>
`;

    }

    // Helper
    wait(time) {
        return new Promise(resolve => {
            return setTimeout(resolve, time * 1000);
        });
    };
    tick() {
        return new Promise(resolve =>  {
            return setTimeout(resolve, 10);
        });
    };
    blur() {
        let activeElement = undefined;
        if(document.activeElement) {
            activeElement = document.activeElement;
            document.activeElement.blur();
        }
        return activeElement;
    };
    generateRandomId() {
        const id = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
            let r = Math.random() * 16 | 0;
            let v = c === 'x' ? r : r & 0x3 | 0x8;
            return v.toString(16);
        });
        return 'notie-' + id;
    };

    // Meldung entfernen
    removeFromDocument(id) {
        const element = document.getElementById(id);
        if (!element) return;

        if (element.listener) window.removeEventListener('keydown', element.listener);

        element.classList.add('closed');
        this.wait(0.3).then(() => {
            if(element.parentNode) element.parentNode.removeChild(element);
        });
    };

    // Alle Meldungen ausblenden
    hideAll() {
        const notis = document.querySelectorAll('.notification');
        if(notis.length) {
            notis.forEach($noti => {
                this.removeFromDocument($noti.id);
            });
        }
    };

    // Erfolgsmeldung anzeigen
    success(header, text='', showCloseBtn=false, closeAfter=6) {
        this.build(header, text, 'success', showCloseBtn, closeAfter);
    }

    // Fehlermeldung anzeigen
    error(header, text='', showCloseBtn=true, closeAfter=0) {
        this.build(header, text, 'error', showCloseBtn, closeAfter);
    }

    // Meldung erstellen
    build(header, text='', type='', showCloseBtn=true, closeAfter=6) {

        this.hideAll();

        let element = document.createElement('div');
        const id = this.generateRandomId();
        element.id = id;
        element.classList.add('notification');
        element.classList.add('closed');

        element.innerHTML = this.html;

        // Inhalte einfügen
        const elHeader = element.querySelector('.text > p.header');
        const elText = element.querySelector('.text > p:last-child');
        const elBtn = element.querySelector('.btn');
        elHeader.innerHTML = header;
        elText.innerHTML = text;
        const svgs = element.querySelectorAll('.icon > svg');
        svgs.forEach($svg => {
            $svg.style.display = 'none';
        });
        if(type != '') {
            element.classList.add(type);
            const svg = element.querySelector('.icon > svg.'+type);
            svg.style.display = '';
        }
        if(!showCloseBtn) {
            elBtn.style.display = 'none';
        }

        // in Markup einfügen
        element = document.body.appendChild(element);

        // Einblenden
        this.tick().then(() => {
            element.classList.remove('closed');
        });

        // Schliessen mit Button
        if(showCloseBtn) {
            const lastActiveElement = this.blur();
            const btns = element.querySelectorAll('.btn button');
            btns.forEach($btn => {
                $btn.addEventListener('click', event => {
                    this.removeFromDocument(id);
                    if(lastActiveElement) {
                        lastActiveElement.focus();
                    }
                });
                $btn.focus();
            });
        }

        // Schliessen nach Zeit
        if(closeAfter > 0) {
            this.wait(closeAfter).then(() => {
                this.removeFromDocument(id);
            });
        }
    }
}